import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/big-screen',
    name: 'BigScreen',
    component:()=>import(/* webpackChunkName: "big_screen" */ '../views/big_screen.vue')
  },
  {
    path: '/small-screen',
    name: 'SmallScreen',
    component: ()=>import(/* webpackChunkName: "small_screen" */ '../views/small_screen.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
